var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"plugin-card-rental-stream"},[_c('div',{staticClass:"plugin-card-rental-stream__container"},[_c('ui-graph',{attrs:{"data":_vm.data,"categories":_vm.categories,"is-stacked":""}})],1),(_vm.comment)?_c('div',{staticClass:"plugin-card-rental-stream__comment",domProps:{"textContent":_vm._s(_vm.comment)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }